/* Elaine · portada C · lo único que el DOM del tema no puede resolver solo.
   19-sep-2026. Dos trabajos y nada más:
     1) las flechas de los dos rieles (Lo más querido y Por colección);
     2) el revelado de las fotos, que respeta `prefers-reduced-motion` y se apaga solo.

   Todo lo que en el mockup hacía `propuesta.js` sobre la foto fija (envolver la
   niebla, partir el título, recortar la frase de la banda, mudar el enlace de
   preguntas) aquí ya nace del Liquid: el DOM sale armado del servidor y no hay un
   parpadeo de reacomodo. Este archivo no reescribe texto, no mueve nodos de
   contenido y no toca precios.

   ═══ POR QUÉ CADA ENGANCHE SE MARCA ANTES DE PONERSE ═══
   Dos secciones cargan este archivo (el riel de Lo más querido y el de Por
   colección), y dos etiquetas `<script src>` con la misma URL se descargan una vez
   pero SE EJECUTAN DOS. Sin marca, cada flecha quedaba con dos escuchas y el riel se
   desplazaba el doble: medido, 652 px de salto donde la tarjeta más su separación
   piden 326. Eso no se ve en una captura; solo se ve empujando el botón.

   La marca va por ELEMENTO y no como un candado global de «ya corrí», a propósito:
   en el editor de temas las secciones se vuelven a pintar una por una, y un candado
   global dejaría sin flechas a la sección recién repintada. Con la marca en el
   elemento, lo viejo se respeta y lo nuevo se engancha. */
(() => {
  'use strict';
  const reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ─── 1 · Flechas de riel ────────────────────────────────────────────────── */
  function montarFlechas(raiz) {
    raiz.querySelectorAll('[data-ec-rail]').forEach((controls) => {
      if (controls.dataset.ecMontado === '1') return;
      const riel = document.getElementById(controls.dataset.ecRail);
      if (!riel) return;
      controls.dataset.ecMontado = '1';
      controls.querySelectorAll('button[data-ec-dir]').forEach((boton) => {
        const dir = Number(boton.dataset.ecDir);
        boton.addEventListener('click', () => {
          const primera = riel.firstElementChild;
          const paso = primera ? primera.getBoundingClientRect().width + 24 : riel.clientWidth;
          riel.scrollBy({ left: dir * paso, behavior: reducido.matches ? 'instant' : 'smooth' });
        });
      });
    });
  }

  /* ─── 2 · Revelado de fotos ──────────────────────────────────────────────── */
  /* El contrato de movimiento protege el dinero y la prosa: se revela la FOTO,
     nunca la tarjeta ni la sección que la contiene, así que el nombre y el precio
     jamás se mueven. */
  const GRUPOS = ['.ec-loved__media', '.ec-cat .ec-photo-window', '.ec-coll .ec-photo-window', '.ec-journal__media'];
  let observador;

  function montarRevelado() {
    observador?.disconnect();
    const objetivos = [];
    GRUPOS.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el, i) => {
        el.style.setProperty('--ec-phase', i < 8 ? i : 0);
        objetivos.push(el);
      });
    });
    objetivos.forEach((el) => {
      el.classList.remove('ec-reveal', 'ec-in');
      delete el.dataset.revealMode;
    });
    if (reducido.matches || !objetivos.length) return;
    const conLinea = CSS.supports('animation-timeline: view()');
    if (!conLinea && !('IntersectionObserver' in window)) return;
    const pendientes = new Set(objetivos);
    if (!conLinea) {
      observador = new IntersectionObserver((entradas) => {
        entradas.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('ec-in');
          observador.unobserve(e.target);
          pendientes.delete(e.target);
          if (!pendientes.size) observador.disconnect();
        });
      }, { threshold: .08 });
    }
    objetivos.forEach((el) => {
      el.dataset.revealMode = conLinea ? 'timeline' : 'observer';
      el.classList.add('ec-reveal');
      if (!conLinea) observador.observe(el);
    });
  }

  function arrancar() {
    montarFlechas(document);
    montarRevelado();
  }

  arrancar();
  reducido.addEventListener('change', arrancar);
  /* El editor de temas repinta una sección a la vez: se engancha solo la nueva. */
  document.addEventListener('shopify:section:load', (e) => {
    montarFlechas(e.target || document);
    montarRevelado();
  });
})();
